import { IonSegment, IonSegmentButton, IonLabel } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { resetDocumentList, setSegmentSelected } from "../../../store/documentsSignerList";
import { selectSegmentSelected } from "../../../store/documentsSignerList/selectors/selectSegmentSelected";

export const SegmentSelector = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);

  const handleSegmentChange = async (value: string) => {
    dispatch(setSegmentSelected(value!));
    dispatch(resetDocumentList());
    await dispatch(fetchDocuments());
  };

  return (
    <IonSegment
      color="primary"
      onIonChange={({ detail: { value } }) => handleSegmentChange(value!)}
      value={segmentSelected}
      style={{ maxWidth: 500 }}
      mode="ios"
    >
      <IonSegmentButton value="pending" color="light">
        <IonLabel>Mis pendientes</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="signed" color="light">
        <IonLabel>Todos</IonLabel>
      </IonSegmentButton>
    </IonSegment>
  );
};
